import { type PropsWithChildren } from 'react'
import { Box, useIsMobileVariant } from '@dhl-ui/components'

type Props = PropsWithChildren<{
  mb?: number

  mt?: number
}>

/**
 * Our mobile version is a full wide screen, this ContentRow can be used when
 * it does need indentation for a specific row. This indentation will only be
 * added on mobile variants.
 * @warning will add indentation only on MOBILE
 */
export const ContentRow = ({ children, mb, mt }: Props) => {
  const isMobile = useIsMobileVariant()

  if (!isMobile) {
    return children
  }

  return <Box sx={{ px: 2, mb, mt }}>{children}</Box>
}
